import { UserProfile } from '../data/user-profile.do';

export interface IDataWithUserProfile {
  userProfile: UserProfile;
}

export function isDataWithUserProfile(value: unknown): value is IDataWithUserProfile {
  if (typeof value !== 'object' || value === null) {
    return false;
  }
  return (value as { userProfile: unknown }).userProfile instanceof UserProfile;
}
